/**
 * Replaces regex matches with an empty tag while streaming, or keeps the original match when complete
 * @param {string} text - Text to process
 * @param {RegExp} regex - Regex pattern to match
 * @param {string} tagName - Tag name for the empty replacement (e.g., "graph", "dashboard")
 * @param {boolean} complete - Whether the message is complete
 * @returns {string} Processed text
 */
export const replaceTagWhileStreaming = (text, regex, tagName, complete) => {
  return text.replace(regex, (match) => {
    if (complete) {
      return match;
    }
    return `<${tagName}></${tagName}>`;
  });
};
